import { render } from "./Staking.vue?vue&type=template&id=6a7fc4b2&scoped=true"
import script from "./Staking.vue?vue&type=script&lang=js"
export * from "./Staking.vue?vue&type=script&lang=js"

import "./Staking.vue?vue&type=style&index=0&id=6a7fc4b2&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/weapsmithing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7fc4b2"]])

export default __exports__